<template>
  <!-- <div class="tab-pane active" id="category-tab-pane">
    <div class="row justify-content-center" v-show="parentcontainer =='category_tab'">
      <div class="col-12 col-md-8 py-5 text-center">
        <h2 class="text-primary font-weight-thin mb-4">{{ __('lang.start.tab.configuration.yoursconfiguration') }}</h2>
      </div>
    </div> -->
  <div>
    <form class="needs-validation" action="/ergebnis/" method="post" novalidate>
      <div class="row mb-5 justify-content-center" v-show="parentcontainer =='category_tab'">
      <div class="col-12 text-center col-md-8">
          <p><a :class="'btn btn-block col-md-6 mx-auto '+ (btn_cat_active ? 'btn-primary' : 'btn-gray-50')" role="button" data-toggle="modal"
              data-target="#categoryModal" data-content="type-filter" @click="getCategories">
              <svg class="icon">
                <use xlink:href="/assets/img/icon-sprite.svg#global.filter" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
              </svg>{{ this.__('lang.btn.op.categories.select')}}
            </a></p>
          <p class="small result" data-global-count="0">{{ btn_typefilter_txt }}</p>
        </div>
      </div>
      <div class="row justify-content-center">
        <div :class="'col-12 pb-5 text-center '+ (parentcontainer =='category_tab' ? 'col-md-8':'')">
          <div class="form-row">
            <div class="form-group col-6">
              <label class="col-form-label col-form-label-sm">{{ __('lang.airflowrate')}}</label>
              <div class="input-group w-100">
                <b-form-input class="form-control rounded-left" id="airflow" v-model="op.airflow" trim required
                  tabindex="1">
                </b-form-input> <!-- :state="state_airflow" -->
                <div class="input-group-append">
                  <b-form-select class="custom-select" id="airflowunits" v-model="op.airflowunits"
                    :options="airflowunits_options" name="airflowunits" @change="updateUnitsAirflow"></b-form-select>
                </div>
                <div class="invalid-feedback">{{ __('lang.message.required.airflowrate')}}</div>
              </div>
            </div>
            <div class="form-group col-6">
              <label class="col-form-label col-form-label-sm">{{ __('lang.externalpressure')}}</label>
              <div class="input-group w-100">
                <b-form-input class="form-control rounded-left" id="pressure" v-model="op.pressure" trim required
                  tabindex="2">
                </b-form-input> <!-- :state="state_pressure" -->
                <div class="input-group-append">
                  <b-form-select class="custom-select" id="pressureunits" v-model="op.pressureunits"
                    :options="pressureunits_options" name="pressureunits" @change="updateUnitsPressure"></b-form-select>
                </div>
                <div class="invalid-feedback">{{ __('lang.message.required.externalpressure')}}</div>
              </div>
            </div>
          </div>
          <a class="btn btn-block btn-sm border-bottom mb-3 d-flex align-items-center text-left no-gutters collapsed"
            role="button" data-toggle="collapse" data-target="#options" aria-expanded="false"
            aria-controls="options"><span class="col-auto pr-3">
              <svg class="icon m-0">
                <use xlink:href="/assets/img/icon-sprite.svg#global.collapse" xmlns:xlink="http://www.w3.org/1999/xlink">
                </use>
              </svg></span><span class="col-auto">{{ __('lang.heliosselect.jumbotron.optionen')}}</span>
          </a>
          <div class="collapse" id="options">

            <div class="form-row pb-5">
              <div class="form-group col-6 mb-0">
                <label class="col-form-label col-form-label-sm">{{ __('lang.deviation')}} {{
                __('lang.airflowrate')}} {{
                __('lang.op.deviation.inpercent')}}</label>
              </div>
              <div class="form-group col-6 mb-0">
                <label class="col-form-label col-form-label-sm">{{ __('lang.deviation')}} {{
                __('lang.op.pressure')}} {{__('lang.op.deviation.inpercent')}}</label>
              </div>
              <div class="form-group col-6 mb-0">
                <b-form-slider @slide-start="slideStart" @slide-stop="slideStop" class="tolerance volumen d-block mr-1"
                  ref="rangeAirflowDeviation" v-model="rangeAirflowValue" :range="true" :min="-80" :max="80" :step="1"
                  :tooltip="tt_always" :tooltip_position="tt_pos"></b-form-slider>
                <!--  :formatter="tt_format" -->
              </div>
              <div class="form-group col-6 mb-0">
                <b-form-slider @slide-start="slideStart" @slide-stop="slideStop" class="tolerance druck d-block ml-1"
                  ref="rangePressureDeviation" v-model="rangePressureValue" :range="true" :min="-80" :max="80" :step="1"
                  :tooltip="tt_always" :tooltip_position="tt_pos"></b-form-slider>
                <!--  :formatter="tt_format" -->
              </div>
            </div>


            <div class="form-row justify-content-center">
              <div class="form-group col-6">
                <label class="col-form-label col-form-label-sm text-secondary" for="pressuretype">{{
                __('lang.externalpressuretyp')}}</label>
                <b-form-select class="form-control custom-select border" id="pressuretype" v-model="op.pressuretype"
                  :options="pressuretype_options" name="pressuretype" required></b-form-select>
              </div>
              <div class="form-group col-6">
                <label class="col-form-label col-form-label-sm text-secondary" for="maxdba">{{
                __('lang.op.maxdba')}}</label>
                <b-form-input class="form-control" type="number" min="0" id="maxdba" step="1" name="maxdba"
                  v-model="op.maxdba"></b-form-input>
              </div>
            </div>
          </div>
          <div class="form-row justify-content-center mb-3">
            <div class="form-group col-12 col-md-6 mb-0">
              <button :class="'btn btn-block '+ (btn_cat_active ? 'btn-gray-50': 'btn-primary')" @click.prevent="set_contentnav" :disabled="state_button"
                tabindex="4">
                <svg class="icon">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.form.send"
                    xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg>{{ __('lang.btn.search')}}
              </button>
            </div>
          </div>
          <div class="form-row justify-content-center">
            <div class="form-group col-12 col-md-6 mb-0">
              <button class="btn btn-sm btn-white" type="reset" @click.prevent="resetOperatingPoint">
                <svg class="icon">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.form.reset"
                    xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg>{{ __('lang.btn.op.reset')}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div class="modal fade" id="categoryModal" tabindex="-1" aria-hidden="true" data-backdrop="static"  data-keyboard="false">
      <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
        <div class="modal-content rounded-lg border-0 shadow-lg">
          <div class="modal-header justify-content-end align-items-center border-0 px-4 row">
            <div class="col-md-6 col-sm-12 text-left">
              <a class="btn btn-sm btn-link global-select-all" id="all_check" role="button"
                data-global-count="0" @click.prevent="$refs.categories.setcheckedall(true,'op')">
                <svg class="icon icon-xs">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.check" xmlns:xlink="http://www.w3.org/1999/xlink">
                  </use>
                </svg>{{__('lang.btn.select_all')}}</a><a class="btn btn-sm btn-link global-deselect-all" id="all_uncheck"
                role="button" @click.prevent="$refs.categories.setcheckedall(false,'op')">
                <svg class="icon icon-xs">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.close" xmlns:xlink="http://www.w3.org/1999/xlink">
                  </use>
                </svg>{{__('lang.btn.unselect_all')}}</a><a class="btn btn-sm btn-link global-collapse-show-all"
                role="button" @click.prevent="$refs.categories.setcollapseall(true)">
                <svg class="icon icon-xs">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.collapse" xmlns:xlink="http://www.w3.org/1999/xlink">
                  </use>
                </svg>{{__('lang.collapse.expandall')}}</a><a class="btn btn-sm btn-link global-collapse-hide-all"
                role="button" @click.prevent="$refs.categories.setcollapseall(false)">
                <svg class="icon icon-xs">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.collapse-up"
                    xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg>{{__('lang.collapse.collapseall')}}
              </a>
            </div>

            <div class="col-md-6 col-sm-12 text-right">
                <button class="btn btn-gray-50 text-white px-4 pull-right col-md-3 col-sm-12" type="reset" data-dismiss="modal"
                  @click.prevent="$refs.categories.restoreCategories">
                  <svg class="icon icon-inline">
                    <use xlink:href="/assets/img/icon-sprite.svg#global.form.reset" xmlns:xlink="http://www.w3.org/1999/xlink">
                    </use>
                  </svg>{{__('lang.btn.cancel')}}
                </button>

                <button class="btn btn-primary border-0 col-md-3 col-sm-12" type="button" data-dismiss="modal" aria-label="Close"
                  @click.prevent="$refs.categories.storeCategories">
                  <svg class="icon icon-inline">
                    <use xlink:href="/assets/img/icon-sprite.svg#global.form.send" xmlns:xlink="http://www.w3.org/1999/xlink">
                    </use>
                  </svg>{{__('lang.btn.submit')}}
                </button>
                <button class="close m-1 d-none" type="button" id="closecategoriesModal" data-dismiss="modal"
                  aria-label="Close"><span aria-hidden="true">
                    <svg class="icon icon-xs">
                      <use xlink:href="/assets/img/icon-sprite.svg#global.close" xmlns:xlink="http://www.w3.org/1999/xlink">
                      </use>
                    </svg></span>
                </button>
            </div>
          </div>
          <div class="modal-body">
            <categories ref="categories" parentID="tab_op"></categories>
          </div>
        </div>
        <!-- </div> -->

      </div>
    </div>
  </div>
</template>

<script>
    //import operatingpointAPI from './services/api/operatingpointAPI.js'
    //--import axios from 'axios'
import categories from './Categories'
import operatingpointApi from './services/api/operatingpointAPI'
var countwatchairflow = 0
var countwatchpressure =0

    export default {
        components: {
            categories
        },
        props: {
          parentcontainer: '',
        },
        computed: {
           /*  actionarealoaded: {
              get() {
                return this.setOptionsValuesLabels(this.$store.state.operatingpoint.actionarealoaded)
              },
              set(value) {
                this.$store.commit('operatingpoint/updateactionarealoaded', value);
              }
            },  */
            state_airflow() {
                return this.op.airflow > 0

            },
            state_pressure() {
                return this.op.pressure > 0
            },
            state_button() {
              var cat = this.selectedcategories
              var cat_count = parseInt(Object.keys(cat).filter(key => cat[key] == true).length)

                //&& Object.keys(this.selectedcategories).filter(key => cat[key] == true).length > 1
              return !(this.op.airflow > 0 && this.op.pressure > 0 && cat_count>0)
            },
            invalidFeedback() {
                if (this.op.airflow < 100) {
                    return 'Enter greater 100'
                }
                return 'Please enter something.'
            },
            op: {
                get () {
                    return this.$store.state.operatingpoint.op;
                },
                set(value){
                 this.$store.commit('operatingpoint/updateop',value);
                }
            },
            pressuretype_options: {
              get () {
                return this.setInputLabels(this.$store.state.operatingpoint.op.pressuretype_options)
              }
            },
            airflowunits_options: {
              get () {
                return this.setOptionsValuesLabels(this.$store.state.operatingpoint.op.airflowunits_options)
              }
            },
            pressureunits_options: {
              get () {
                return this.setOptionsValuesLabels(this.$store.state.operatingpoint.op.pressureunits_options)
              }
            },
            btn_typefilter_txt_alt :function () {
              var txt = this.__('lang.heliosselect.jumbotron.btn.typenfilter');
              var cat= this.selectedcategories
              var append_txt='';

              if(Object.keys(cat).filter( key => cat[key]==true).length > 0) {
                append_txt=Object.keys(cat).join(', ')
              }

              if(Object.keys(cat).filter( key => cat[key]==true).length>1) txt=Object.keys(cat).filter( key => cat[key]==true).length + ' '+ this.__('lang.heliosselect.jumbotron.btn.typenfilter.selectedmulti')
              else if(Object.keys(cat).filter( key => cat[key]==true).length==1) txt=Object.keys(cat).filter( key => cat[key]==true).length + ' ' + this.__('lang.heliosselect.jumbotron.btn.typenfilter.selectedone')

              return txt+append_txt

            },
            allCategories: {
              get () {
                return this.$store.state.operatingpoint.categories
              }
            },
            btn_typefilter_txt :function () {
              var cat= this.$store.state.operatingpoint.selectedCategories
              var txt = this.__('lang.start.tab.configuration.nocatselected') // this.__('lang.heliosselect.jumbotron.btn.typenfilter');
              var append_txt=''
              var allcategories = this.allCategories;

              var count_allcat = 0;
              var selcats_new = [];


              allcategories.forEach(function (catlevel1) {
                if (catlevel1.subcategories.length > 0) {
                  count_allcat += catlevel1.subcategories.filter(key => key.f_filter == 1).length
                }

              });


              Object.keys(cat).filter(key => cat[key] == true).forEach(c => {

                allcategories.forEach(function (clevel1) {
                  if (clevel1.subcategories.length > 0) {
                    clevel1.subcategories.forEach(sc => {
                      if (sc.categoryChildId == c) {
                        selcats_new.push({
                          id: sc.categoryChildId,
                          desc: sc.description_short
                        });


                      }
                    })

                  }

                });

              })



              if(Object.keys(cat).filter( key => cat[key]==true).length == 0) {
                  append_txt = ''
                  this.btn_cat_active = true;
              }
              else {

                //--!!var selcats = this.$store.state.operatingpoint.descselectedCategories;
                var selcats= selcats_new

                this.btn_cat_active = false;
                if (selcats.length>0){
                   var arr = selcats.map(function (categories) {
                    return categories.desc
                  })
                  txt = arr.shift() //firstItem
                  // var tooltip=arr.join(',')
                  if(Object.keys(cat).filter( key => cat[key]==true).length >1) {

                    var cat_count= parseInt(Object.keys(cat).filter( key => cat[key]==true).length - 1)
                    if(count_allcat==cat_count) {
                      return this.__('lang.overview.all');
                    }
                    else append_txt = '+ ' + cat_count + ' ' + this.__('lang.overview.more');

                  }
                }

              }
              return txt + ' ' +append_txt
            },

            selectedcategories:{
              get () {
                    return this.$store.state.operatingpoint.selectedCategories;
              },
              set(value) {
                 this.$store.commit('operatingpoint/updateSelectedCategories', value);
              },

            },
            rangeAirflowValue: {
                get () {
                   return this.$store.state.operatingpoint.op.airflow_deviation

                },
                set (value) {
                  var range_arr=[]
                  range_arr= this.makearray(value,this.$store.state.operatingpoint.op.airflow_deviation)
                  this.$store.commit('operatingpoint/updateairflowdeviation',range_arr);
                }
            },
            rangePressureValue: {
                get () {
                  return this.$store.state.operatingpoint.op.pressure_deviation
                },
                set (value) {
                  var range_arr=[]
                  range_arr= this.makearray(value,this.$store.state.operatingpoint.op.pressure_deviation)
                  this.$store.commit('operatingpoint/updatepressuredeviation',range_arr);
                }
            },
            user: {
              get() {
                return this.$store.state.user.user
              },
              set(value) {
                this.$store.commit('user/updateUser', value)
              }
            },
            formData: {
              get () {
                return this.$store.state.user.formData
              },
              set (value) {
                this.$store.commit('user/updateFormData', value)
              }
            },
        },
        data() {
          return {
                    min: -20,
                    max: 20,
                    tt_always: 'always',
                    tt_pos: 'bottom',
                    btn_cat_active: true,
                    categories:[],
          }
        },
        methods: {
            slideStart () {
                //console.log('slideStarted')
            },
            slideStop () {
                //console.log('slideStopped')
            },
            makearray(val,storedval) {
              var range_arr=[]
              var v=[]
              if (Array.isArray(val)) {
                val.forEach(function(e, i){
                    v[i] = parseInt(e);
                });
                range_arr= [v[0],v[1]]
              } else {
                range_arr=storedval;
              }
              return range_arr
            },
            tt_format: function(val) {
                let prefix = '+';
                let suffix = ' %';
                if (Array.isArray(val)) {
                    val.forEach(function(e, i){
                        val[i] = parseInt(e) > 0 ? prefix+parseInt(e)+suffix : parseInt(e)+suffix;
                    });
                    return val[0] + " : " + val[1];
                } else {
                    return val;
                }
			      },
            getPressureType () {
                var opt_arr=[];
                opt_arr.push({value: 'stat', text: this.__('lang.externalpressuretyp.stat')});
                opt_arr.push({value: 'tot', text: this.__('lang.externalpressuretyp.tot')});
                return opt_arr;
            },
            setInputLabels: function(value){
              value.forEach(function(item){
                if(item.hasOwnProperty('value')){
                  item.value = this.__(item.value)
                }
                if(item.hasOwnProperty('text')){
                  item.text = this.__('lang.externalpressuretyp.'+item.value)
                }
              }.bind(this))
              return value;
            },
            //for units :
            setOptionsValuesLabels: function(value){
              var array =[];
              for(var i = 0; i < value.length; i++){
                array.push({value: value[i].value, text: this.__(value[i].text)})
              }
              return array;
            },
            updateUnitsAirflow() {
              countwatchairflow = 0
              this.$store.commit('operatingpoint/updateairflowunits',this.op.airflowunits);
            },
            updateUnitsPressure() {
              countwatchpressure = 0
              this.$store.commit('operatingpoint/updatepressureunits', this.op.pressureunits);
            },

            set_contentnav() {
              this.$root.$refs.main.listenerchild({ nav: "2", searchflag: "op"}); // , op: this.op
            },

            resetOperatingPoint() {
              //what must be reset
              //this.$store.dispatch('operatingpoint/resetState', null);
              this.selectedcategories = []
              this.op.airflow = ''
              this.op.pressure = ''
              this.op.pressuretype = 'stat'
              this.op.pressureunits = 5,
              this.op.airflowunits = 1
              this.op.maxdba = ''
              this.airflow_deviation = this.makearray([-20, 20], [-20, 20])
              this.pressure_deviation= this.makearray([-20, 20], [-20, 20])

              //if (this.user.auth)
                this.$store.dispatch('operatingpoint/InitLoad', this.$store.state.user.user);
              //else  this.$store.dispatch('operatingpoint/resetState', null);
          },

            getCategories() {
              this.$refs.categories.getCategories()
            },
            async getAllCategories() {
              var body = []


              body.push({
                language_id: this.$lang().locale, //navigator.language,
              })
              var response = await operatingpointApi.getCategories(body);
              this.categories = response.categories;

              this.$store.commit('operatingpoint/setCategories', response.categories)

            },



        },
        created(){
            //this.$store.dispatch('operatingpoint/InitLoad','');           //,this.getPressureType());
            countwatchairflow = 0
            countwatchpressure=0
            this.getAllCategories();
        },
        mounted () {

          //!--if (!this.$store.state.operatingpoint.loaded || this.$store.state.operatingpoint.loaded == '' )   this.$store.dispatch('operatingpoint/InitLoad', this.$store.state.user.user);

          //else this.$store.commit('operatingpoint/setDefaults', null); */

           //this.$lang().setLocale('de')  //das funktioniert!  kann man for lang switcher nutzen

            window._locale = this.$lang().locale

        },
        watch: {

          'op.airflowunits': {
            immediate: true,
            deep: true,
            handler(newairflowunits, oldairflowunits) {
                console.log( this.formData.units)
              if (countwatchairflow ==0 && newairflowunits!==undefined && oldairflowunits!==undefined  ) {

                    var units = this.formData.units.length > 0 ? this.formData.units :  this.op.units
                    var val = parseFloat(this.op.airflow)


                    //convert old und new units to standard units
                    var old_fak = units.filter(item => item.id == oldairflowunits).map(function (u) { return u.convert_fak })
                    var new_fak = units.filter(item => item.id == newairflowunits).map(function (u) { return u.convert_fak })


                    if (val > 0) {
                      console.log('val:',val)
                      //convert from old to new units
                      val = val * (old_fak / new_fak)
                      this.op.airflow = val > 0 ? parseFloat(val).toFixed(2) : ''
                      countwatchairflow++
                    }
                  }

            }
          },
          'op.pressureunits': {
            immediate: true,
            deep: true,
            handler(newpressureunits, oldpressureunits) {

              if (countwatchpressure == 0 && newpressureunits!==undefined && oldpressureunits!==undefined) {

                var units = this.formData.units.length > 0 ? this.formData.units :  this.op.units
                var val = parseFloat(this.op.pressure)
                //convert old und new units to standard units
                var old_fak = units.filter(item => item.id == oldpressureunits).map(function (u) { return u.convert_fak })
                var new_fak = units.filter(item => item.id == newpressureunits).map(function (u) { return u.convert_fak })


                if (val > 0) {
                  //convert from old to new units
                  val = val * (old_fak / new_fak)
                  this.op.pressure = val > 0 ? parseFloat(val).toFixed(2) : ''
                  countwatchpressure++
                }
              }

            }
          }



        },

    }


</script>
<style>
button .icon-inline {
    vertical-align: middle; /* Align SVG vertically with text */
    width: 16px; /* Adjust width of the icon */
    height: 16px; /* Adjust height of the icon */
    margin-right: 8px; /* Adds spacing between the icon and the text */
    display: inline-block; /* Keep the SVG inline with the text */
}

button {
    display: inline-flex; /* Aligns the SVG and text inline in buttons */
    align-items: center; /* Ensures vertical alignment of content */
    white-space: nowrap; /* Prevent text from wrapping */
    min-width: 130px;
}

/* Align all buttons to the right in the modal */
.text-right {
    text-align: right;
}

/* Additional styling for button layout consistency */
.col-md-3 {
    margin-left: 10px; /* Adds spacing between the buttons */
}

/* Custom adjustments for close button */
button.close .icon-xs {
    width: 12px;
    height: 12px;
}
</style>
